import script from "./PatientBilling.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientBilling.vue?vue&type=script&setup=true&lang=js"

import "./PatientBilling.vue?vue&type=style&index=0&id=0a6dd73a&lang=css"
import "./PatientBilling.vue?vue&type=style&index=1&id=0a6dd73a&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a6dd73a"]])

export default __exports__